import {createFileRoute, redirect} from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/_admin/_legacy/bulk-sms")({
  beforeLoad: () => {
    throw redirect({to: "/admins/bulk-sms", replace: true});
  },
});
